import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Renderer} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {TooltipCoordinator} from '../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {fontWeights, secondaryFontSizes} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {AtomLine} from '../../rules/ruleEditor/expressions/atomLine';

/*
 * Props.
 */

interface EditorSectionProps {
  description: ReactNode;
  renderTooltip?: Renderer;
  renderRight?: Renderer;
}

/*
 * Style.
 */

const StyledEditorSection = styled.section`
  display: grid;
  grid-row-gap: 10px;
`;

const StyledEditorSectionHeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledEditorSectionAtomLine = styled(AtomLine)`
  color: ${(p) => p.theme.greys.shade70};

  font-size: ${secondaryFontSizes[VisualSizesEnum.LARGE]};
  font-weight: ${fontWeights.semibold};
`;

/*
 * Component.
 */

export const EditorSection: FC<EditorSectionProps> = (props) => {
  const theme = useUserTheme();
  const {description, renderTooltip, renderRight, children} = props;

  return (
    <StyledEditorSection>
      <StyledEditorSectionHeaderDiv>
        <StyledEditorSectionAtomLine>
          <span>{description}</span>
          {renderTooltip && <TooltipCoordinator iconColor={theme.greys.shade70} render={renderTooltip} />}
        </StyledEditorSectionAtomLine>
        {renderRight?.()}
      </StyledEditorSectionHeaderDiv>
      <div>{children}</div>
    </StyledEditorSection>
  );
};
